import AccordionItem from 'components/ui/Accordion/Accordion';
import CheckBoxGroup from 'components/ui/Form/OnboardingCheckBoxGroup/OnboardingCheckBoxGroup';
import TextInput from 'components/ui/Form/TextInput/TextInput';
import {
    DIRECT_OWNER_OPTIONS,
    OWNER_PERCENTAGE_OPTIONS,
    PROFESSIONAL_POSITION_OPTIONS,
    SIGNER_OPTIONS,
} from 'constants/common';
import AutoComplete from 'components/ui/Form/AutoComplete/AutoComplete';
import styles from '../CrpForm.module.scss';
import {useFormContext} from 'react-hook-form';
import {CrpVariants} from 'constants/businessPartnerAttributes';
import {CrpSelectedRoles} from 'components/pages/OnboardingPage/components/CrpForm';

interface IProps {
    formOfControl?: string;
    selectedRoles: CrpSelectedRoles;
}

const CrpAdditionalForm = ({formOfControl, selectedRoles}: IProps) => {
    const {watch} = useFormContext();
    const directOwner = watch('directOwner');
    const ownerOptions =
        formOfControl === '3'
            ? [...DIRECT_OWNER_OPTIONS, {value: 'null', label: 'No'}]
            : DIRECT_OWNER_OPTIONS;

    return (
        <AccordionItem
            toggleType="title"
            openStatus
            className={styles.accordionContainer}
            accordionKey="signer"
            title={
                <>
                    <span className={styles.groupStatus} />
                    <div className={styles.accordionHeader}>
                        Additional information
                    </div>
                </>
            }
            body={
                <>
                    {selectedRoles.includes(CrpVariants.OWNER) ? (
                        <>
                            <CheckBoxGroup
                                options={ownerOptions}
                                name="directOwner"
                                type="radio"
                                label={`${selectedRoles.includes('currentUser') ? 'Are you' : 'Is the person listed above'} holding capital shares/voting rights directly?`}
                                variant="dark"
                                hidden={formOfControl !== '1'}
                                size="large"
                            />
                            {directOwner === 'yes' ? (
                                <AutoComplete
                                    name="ownerPercentage"
                                    label={`How many percentages ${selectedRoles.includes('currentUser') ? 'do you' : 'does this person'} hold in the company?`}
                                    options={OWNER_PERCENTAGE_OPTIONS}
                                    variant="dark"
                                    valueKey="value"
                                    hidden={formOfControl !== '1'}
                                    size="large"
                                />
                            ) : null}
                        </>
                    ) : null}
                    {selectedRoles.includes(CrpVariants.SIGNER) ? (
                        <CheckBoxGroup
                            options={SIGNER_OPTIONS}
                            label={`How ${selectedRoles.includes('currentUser') ? 'are you' : 'is this person'} authorized to sign?`}
                            name="collectiveSigningRight"
                            type="radio"
                            variant="dark"
                            size="large"
                        />
                    ) : null}
                    {selectedRoles.includes(CrpVariants.OWNER) ||
                    selectedRoles.includes(CrpVariants.ADMIN) ||
                    selectedRoles.includes(CrpVariants.SIGNER) ? (
                        <>
                            <AutoComplete
                                name="professionalPosition"
                                label="Professional position"
                                options={PROFESSIONAL_POSITION_OPTIONS}
                                variant="dark"
                                size="large"
                            />
                            <TextInput
                                label={`Could you specify ${selectedRoles.includes('currentUser') ? 'your' : "this person's"} professional position?`}
                                placeholder="CEO"
                                name="role"
                                variant="dark"
                                size="large"
                            />
                        </>
                    ) : null}
                </>
            }
        />
    );
};

export default CrpAdditionalForm;
